// extracted by mini-css-extract-plugin
module.exports = {"EmbedLayout":"EmbedLayout","App__Main":"App__Main"};